import React from 'react';
import { Sparkles, Heart, Clock, ArrowRight, Star, CheckCircle2 } from 'lucide-react';
export function LandingPage() {
  return <div className="min-h-screen w-full bg-[#FAF7F5] text-[#2D2D2D] font-sans selection:bg-[#D4A5A5] selection:text-white" data-id="element-2">
      {/* Navigation / Header - Minimal */}
      <nav className="w-full py-4 md:py-6 px-6 md:px-12 flex justify-between items-center max-w-7xl mx-auto" data-id="element-3">
        <div className="text-xl font-serif tracking-wide font-medium" data-id="element-4">
          Lumina Nails
        </div>
        <button className="text-sm font-medium hover:text-[#D4A5A5] transition-colors duration-300" data-id="element-5">
          Acceder
        </button>
      </nav>

      {/* Hero Section */}
      <header className="relative pt-8 pb-16 px-6 md:px-12 lg:pt-20 lg:pb-32 overflow-hidden" data-id="element-6">
        <div className="max-w-7xl mx-auto flex flex-col gap-8 md:gap-16 items-center" data-id="element-7">
          {/* Hero Image - First */}
          <div className="relative w-full max-w-2xl mx-auto" data-id="element-8">
            <div className="absolute -inset-4 bg-[#F8E8E8] rounded-[2rem] -z-10 rotate-2" data-id="element-9"></div>
            <img src="https://cdn.magicpatterns.com/uploads/7H6CcJUgS52x8BexDhasAT/ChatGPT_Image_3_ene_2026,_17_30_21.png" alt="Manos elegantes con manicura rosa suave y accesorios dorados" className="w-full h-auto rounded-[1.5rem] shadow-2xl shadow-[#D4A5A5]/10 object-cover aspect-[4/3]" data-id="element-10" />
          </div>

          {/* Text Content */}
          <div className="flex flex-col gap-5 md:gap-8 z-10 text-center items-center" data-id="element-11">
            <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif leading-[1.1] text-[#2D2D2D]" data-id="element-12">
              El arte de unas uñas perfectas,{' '}
              <span className="italic text-[#D4A5A5]" data-id="element-13">en casa.</span>
            </h1>

            <p className="text-lg md:text-xl text-gray-600 leading-relaxed max-w-lg" data-id="element-14">
              Descubre las últimas tendencias, técnicas profesionales y secretos
              de cuidado para lucir unas manos elegantes sin salir de tu hogar.
            </p>

            <div className="flex flex-col sm:flex-row gap-4 pt-2 md:pt-4" data-id="element-15">
              <button onClick={() => document.getElementById('comprar')?.scrollIntoView({
              behavior: 'smooth'
            })} className="px-8 py-4 bg-[#D4A5A5] text-white rounded-full font-medium text-lg hover:bg-[#C08F8F] transition-all duration-300 shadow-lg shadow-[#D4A5A5]/20 flex items-center justify-center gap-2 group" data-id="element-16">
                Obtener la Guía
                <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" data-id="element-17" />
              </button>
              <button className="px-8 py-4 border border-[#D4A5A5] text-[#8A6A6A] rounded-full font-medium text-lg hover:bg-[#F8E8E8] transition-all duration-300 flex items-center justify-center" data-id="element-18">
                Ver Contenido
              </button>
            </div>

            <div className="flex items-center gap-4 pt-2 md:pt-4 text-sm text-gray-500" data-id="element-19">
              <div className="flex -space-x-2" data-id="element-20">
                {[1, 2, 3, 4].map(i => <div key={i} className="w-8 h-8 rounded-full bg-gray-200 border-2 border-[#FAF7F5] flex items-center justify-center overflow-hidden" data-id="element-21">
                    <div className="w-full h-full bg-[#E5D5D5]" data-id="element-22"></div>
                  </div>)}
              </div>
              <p data-id="element-23">Más de 2.000 mujeres ya lo tienen</p>
            </div>
          </div>
        </div>
      </header>

      {/* Benefits Section */}
      <section className="py-12 md:py-24 px-6 md:px-12 bg-white" data-id="element-24">
        <div className="max-w-7xl mx-auto" data-id="element-25">
          <div className="text-center max-w-2xl mx-auto mb-10 md:mb-20" data-id="element-26">
            <h2 className="text-3xl md:text-4xl font-serif mb-4 md:mb-6 text-[#2D2D2D]" data-id="element-27">
              Más que un simple manual
            </h2>
            <p className="text-lg text-gray-600" data-id="element-28">
              Una guía completa diseñada para transformar tu rutina de cuidado
              personal en un ritual de belleza y bienestar.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-12" data-id="element-29">
            {/* Benefit 1 */}
            <div className="flex flex-col items-center text-center p-4 md:p-8 rounded-2xl hover:bg-[#FAF7F5] transition-colors duration-500" data-id="element-30">
              <div className="w-14 md:w-16 h-14 md:h-16 bg-[#F8E8E8] rounded-full flex items-center justify-center mb-4 md:mb-6 text-[#D4A5A5]" data-id="element-31">
                <Sparkles className="w-7 md:w-8 h-7 md:h-8" data-id="element-32" />
              </div>
              <h3 className="text-xl font-serif font-semibold mb-3 md:mb-4" data-id="element-33">
                Tendencias Actuales
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-34">
                Aprende los estilos minimalistas y elegantes que dominan las
                pasarelas este año. Diseños que elevan cualquier look.
              </p>
            </div>

            {/* Benefit 2 */}
            <div className="flex flex-col items-center text-center p-4 md:p-8 rounded-2xl hover:bg-[#FAF7F5] transition-colors duration-500" data-id="element-35">
              <div className="w-14 md:w-16 h-14 md:h-16 bg-[#F8E8E8] rounded-full flex items-center justify-center mb-4 md:mb-6 text-[#D4A5A5]" data-id="element-36">
                <Heart className="w-7 md:w-8 h-7 md:h-8" data-id="element-37" />
              </div>
              <h3 className="text-xl font-serif font-semibold mb-3 md:mb-4" data-id="element-38">
                Cuidado Saludable
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-39">
                Técnicas que priorizan la salud de tus uñas. Descubre cómo
                fortalecerlas naturalmente mientras las embelleces.
              </p>
            </div>

            {/* Benefit 3 */}
            <div className="flex flex-col items-center text-center p-4 md:p-8 rounded-2xl hover:bg-[#FAF7F5] transition-colors duration-500" data-id="element-40">
              <div className="w-14 md:w-16 h-14 md:h-16 bg-[#F8E8E8] rounded-full flex items-center justify-center mb-4 md:mb-6 text-[#D4A5A5]" data-id="element-41">
                <Clock className="w-7 md:w-8 h-7 md:h-8" data-id="element-42" />
              </div>
              <h3 className="text-xl font-serif font-semibold mb-3 md:mb-4" data-id="element-43">
                Resultados Duraderos
              </h3>
              <p className="text-gray-600 leading-relaxed" data-id="element-44">
                Secretos profesionales para que tu manicura dure semanas
                impecable, ahorrando tiempo y visitas al salón.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Social Proof / Quote */}
      <section className="py-12 md:py-24 px-6 md:px-12 bg-[#F8E8E8]/30" data-id="element-45">
        <div className="max-w-4xl mx-auto text-center" data-id="element-46">
          <div className="flex justify-center gap-1 mb-5 md:mb-8" data-id="element-47">
            {[1, 2, 3, 4, 5].map(i => <Star key={i} className="w-5 h-5 text-[#D4A5A5] fill-current" data-id="element-48" />)}
          </div>
          <blockquote className="text-2xl md:text-4xl font-serif italic text-[#2D2D2D] leading-relaxed mb-5 md:mb-8" data-id="element-49">
            "Nunca pensé que podría lograr este nivel de acabado en casa. Esta
            guía no solo me enseñó técnica, sino a disfrutar el proceso como mi
            momento de paz."
          </blockquote>
          <cite className="not-italic font-medium text-gray-600 block" data-id="element-50">
            — Sofia M., <span className="text-[#D4A5A5]" data-id="element-51">Madrid</span>
          </cite>
        </div>
      </section>

      {/* What's Inside Preview */}
      <section className="py-12 md:py-24 px-6 md:px-12 bg-white" data-id="element-52">
        <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center" data-id="element-53">
          <div className="order-2 lg:order-1 bg-[#FAF7F5] rounded-[2rem] p-6 md:p-12" data-id="element-54">
            <h3 className="text-2xl font-serif mb-5 md:mb-8" data-id="element-55">
              Lo que aprenderás:
            </h3>
            <ul className="space-y-4 md:space-y-6" data-id="element-56">
              {['Preparación profesional de la uña natural', 'Técnica de esmaltado perfecto sin manchas', 'Diseños minimalistas paso a paso', 'Rutina de hidratación profunda', 'Herramientas esenciales (y económicas)'].map((item, idx) => <li key={idx} className="flex items-start gap-4" data-id="element-57">
                  <CheckCircle2 className="w-6 h-6 text-[#D4A5A5] flex-shrink-0 mt-0.5" data-id="element-58" />
                  <span className="text-lg text-gray-700" data-id="element-59">{item}</span>
                </li>)}
            </ul>
          </div>
          <div className="order-1 lg:order-2" data-id="element-60">
            <h2 className="text-3xl md:text-4xl font-serif mb-4 md:mb-6 text-[#2D2D2D]" data-id="element-61">
              Tu salón personal, disponible 24/7.
            </h2>
            <p className="text-lg text-gray-600 leading-relaxed mb-5 md:mb-8" data-id="element-62">
              Olvídate de las citas difíciles de conseguir y los precios
              elevados. Con nuestra guía digital, tienes el conocimiento experto
              en la palma de tu mano, listo para cuando tú decidas dedicarte ese
              tiempo.
            </p>
            <p className="text-lg text-gray-600 leading-relaxed" data-id="element-63">
              Diseñado para principiantes y entusiastas que buscan elevar su
              técnica con un enfoque moderno y sofisticado.
            </p>
          </div>
        </div>
      </section>

      {/* Final CTA */}
      <section id="comprar" className="py-14 md:py-24 px-6 md:px-12 bg-[#2D2D2D] text-[#FAF7F5] text-center" data-id="element-64">
        <div className="max-w-3xl mx-auto" data-id="element-65">
          <h2 className="text-4xl md:text-5xl font-serif mb-4 md:mb-6" data-id="element-66">
            Empieza tu transformación hoy
          </h2>
          <p className="text-xl text-gray-400 mb-6 md:mb-10 leading-relaxed" data-id="element-67">
            Descarga inmediata. Acceso de por vida. Actualizaciones gratuitas.
          </p>
          <div className="flex flex-col items-center gap-4" data-id="element-68">
            <a href="https://cuidarte360.com/cart/55939730112838:1" className="px-10 py-5 bg-[#D4A5A5] text-white rounded-full font-medium text-xl hover:bg-[#C08F8F] transition-all duration-300 shadow-lg shadow-[#D4A5A5]/20 w-full md:w-auto text-center inline-block" data-id="element-69">
              Comprar Ebook —{' '}
              <span className="line-through opacity-60 text-lg" data-id="element-70">$9,99</span>{' '}
              $6,39
            </a>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="py-8 md:py-12 px-6 md:px-12 bg-[#FAF7F5] border-t border-[#E5D5D5]" data-id="element-71">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row justify-between items-center gap-6" data-id="element-72">
          <div className="text-lg font-serif font-medium text-[#2D2D2D]" data-id="element-73">
            Lumina Nails
          </div>
          <div className="flex gap-8 text-sm text-gray-500" data-id="element-74">
            <a href="#" className="hover:text-[#D4A5A5] transition-colors" data-id="element-75">
              Términos
            </a>
            <a href="#" className="hover:text-[#D4A5A5] transition-colors" data-id="element-76">
              Privacidad
            </a>
            <a href="#" className="hover:text-[#D4A5A5] transition-colors" data-id="element-77">
              Contacto
            </a>
          </div>
          <div className="text-sm text-gray-400" data-id="element-78">
            © 2026 Lumina Nails. Todos los derechos reservados.
          </div>
        </div>
      </footer>
    </div>;
}